require('./src/angular-base64-upload.js');
module.exports = 'naif.base64';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-base64-upload/index.js
 ** module id = 675
 ** module chunks = 8
 **/